<template>
  <div>
    <div class="tab">
      <ul>
        <li v-for="(item, index) in list" v-show="index < 12" :key="index" @click="touch(item.id)"
            :class="touchList.indexOf(item.id) >= 0 ? 'selected' : ''">
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
export default {
  name: "SearchTab",
  props: {
    activityType: String,
  },
  data() {
    return {
      touchList: [],
      list: []
    }
  },
  mounted() {
    this.get()
  },
  methods: {
    get() {
      let type = this.activityType ? this.activityType : this.$route.params.activity
      switch (type) {
        case '2000':
          type = 8000
          break
      }
      if (type >= 3000 && type < 4000) {
        type = 7000
      }
      if (type >= 4000 && type < 5000) {
        type = 10000
      }
      this.$http.get(this.$api.label.list2 + type).then(res => {
      // this.$http.get(this.$api.label.list2_old).then(res => {
        let {code, data} = res
        if (code === 0) {
          this.list = data
        }
      })
    },
    touch(index) {
      if (this.touchList.indexOf(index) >= 0) {
        this.touchList.splice(this.touchList.findIndex(e => e === index), 1)
      } else {
        this.touchList.push(index)
      }
      let search = []
      this.touchList.forEach(val => {
        this.list.forEach(name => {
          if (name.id === val) {
            search.push(name.name)
          }
        })
      })
      if (search.length < 1) {
        this.$emit('change', null)
      } else {
        this.$emit('change', JSON.stringify(search))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  ul {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;

    li {
      overflow: hidden;
      white-space: nowrap;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 4px 40px;
      background: #F0F0F0;
      color: #3E3E3E;
      font-size: 22px;
      border-radius: 5px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 166px;
    }

    .selected {
      background: #0090C5;
      color: #ffffff;
    }
  }
}
</style>
